<script>
const defaultBreakpoints = {
    phone: 767,
    tablet: 991,
    desktop: 1275,
    infinite: Infinity
};
export default {
    props: {
        breakpoints: {
            type: Object,
            default: undefined
        }
    },
    data: () => ({
        currentBreakpoint: ''
    }),
    computed: {
        _breakpoints() {
            return Object.assign(defaultBreakpoints, this.breakpoints);
        }
    },
    created() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        handleResize() {
            const clientWidth = window.innerWidth;
            const previousBreakpoint = this.currentBreakpoint;
            if (clientWidth < this._breakpoints.phone) {
                this.currentBreakpoint = 'phone';
            } else if (clientWidth < this._breakpoints.tablet) {
                this.currentBreakpoint = 'tablet';
            } else if (clientWidth < this._breakpoints.desktop) {
                this.currentBreakpoint = 'desktop';
            } else if (clientWidth < this._breakpoints.infinite) {
                this.currentBreakpoint = 'infinite';
            }
            if (previousBreakpoint !== this.currentBreakpoint) {
                this.emitBreakpointChange();
            }
        },
        emitBreakpointChange() {
            this.$eventsBus.$emit('breakpoint-change');
        }
    }
};
</script>
